import './App.css';
import 'material-symbols/outlined.css';
import { BrowserRouter, Route, Routes } from 'react-router';
import Home from './pages/home/Home';
import Calendar from './pages/calendar/Calendar';
import EventDetails from './pages/details/EventDetails';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <div className="container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/event/:id" element={<EventDetails />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
